module.exports = __webpack_public_path__ + "static/media/silver-crown.daa56ca5.svg";